module.exports = __webpack_public_path__ + "static/media/K.af497a86.svg";